import React from "react";
import { cn } from "../../../utils/cn";

interface DashboardCardSkeletonProps {
  className?: string;
  minHeight?: string;
  lines?: number;
}

export default function DashboardCardSkeleton({
  className,
  minHeight = "min-h-[14rem]",
  lines = 4,
}: DashboardCardSkeletonProps) {
  return (
    <div
      className={cn(
        "w-full animate-pulse rounded-[20px] border border-white/[0.08] bg-[#161b22] p-4 sm:p-5",
        minHeight,
        className
      )}
    >
      <div className="mb-4 h-5 w-40 rounded-full bg-white/[0.08]" />
      <div className="mb-6 h-3 w-56 max-w-full rounded-full bg-white/[0.06]" />
      <div className="flex flex-col gap-3">
        {Array.from({ length: lines }, (_, index) => (
          <div
            key={index}
            className="h-10 rounded-xl bg-white/[0.06]"
            style={{ width: `${Math.max(55, 100 - index * 12)}%` }}
          />
        ))}
      </div>
    </div>
  );
}
